// Mapping of county names to their approximate center coordinates and zoom levels
// Add more counties as needed
const countyCoordinates = {
  'Suffolk County MA': { lat: 42.3601, lng: -71.0589, zoom: 11 }, // Boston
  'Essex County MA': { lat: 42.6334, lng: -70.8578, zoom: 10 },
  'Middlesex County MA': { lat: 42.4672, lng: -71.2874, zoom: 10 },
  'Norfolk County MA': { lat: 42.1767, lng: -71.1449, zoom: 10 },
  'Plymouth County MA': { lat: 41.9584, lng: -70.6673, zoom: 10 },
  'Worcester County MA': { lat: 42.3648, lng: -71.8962, zoom: 10 },
  'Ottawa County MI': { lat: 43.0246, lng: -86.2152, zoom: 10 },
  'Kalamazoo County MI': { lat: 42.2459, lng: -85.5882, zoom: 10 },
  'Kent County MI': { lat: 43.0097, lng: -85.5200, zoom: 10 },
  'Cobb County GA': { lat: 33.8999, lng: -84.5641, zoom: 10 },
  'Cherokee County GA': { lat: 34.2515, lng: -84.4803, zoom: 10 },
  "Prince George's County MD": { lat: 38.8268, lng: -76.9030, zoom: 10 },
  'New Castle County DE': { lat: 39.5777, lng: -75.5970, zoom: 10 },
  'Cecil County MD': { lat: 39.5739, lng: -75.9463, zoom: 10 },
  'Wake County NC': { lat: 35.8032, lng: -78.5661, zoom: 10 },
  'Durham County NC': { lat: 36.0222, lng: -78.9030, zoom: 10 },
  'Horry County SC': { lat: 33.9197, lng: -78.9288, zoom: 10 },
  'Mecklenburg County NC': { lat: 35.2633, lng: -80.8544, zoom: 10 },
  'Gaston County NC': { lat: 35.2621, lng: -81.1873, zoom: 10 },
  'Union County NC': { lat: 34.9889, lng: -80.5306, zoom: 10 },
  'York County SC': { lat: 34.9747, lng: -81.1848, zoom: 10 },
  'Lancaster County SC': { lat: 34.7681, lng: -80.7714, zoom: 10 },
  'Richland County SC': { lat: 34.0416, lng: -80.9426, zoom: 10 },
  'Caldwell County TX': { lat: 29.8360, lng: -97.6275, zoom: 10 },
  'Williamson County TX': { lat: 30.6400, lng: -97.6935, zoom: 10 },
  'Bell County TX': { lat: 31.0360, lng: -97.4826, zoom: 10 },
  'Bastrop County TX': { lat: 30.1105, lng: -97.3080, zoom: 10 },
  'Travis County TX': { lat: 30.3322, lng: -97.8060, zoom: 10 },
  // Add more as needed
}

export default countyCoordinates; 